/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SearchLoupePlusIcon64Regular = forwardRef('SearchLoupePlusIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M31.5 19.5a1.5 1.5 0 0 0-3 0v9h-9a1.5 1.5 0 0 0 0 3h9v9a1.5 1.5 0 0 0 3 0v-9h9a1.5 1.5 0 0 0 0-3h-9v-9Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 30C6 16.745 16.745 6 30 6s24 10.745 24 24a23.909 23.909 0 0 1-6.002 15.877l11.063 11.062a1.5 1.5 0 0 1-2.122 2.122L45.877 47.998A23.909 23.909 0 0 1 30 54C16.745 54 6 43.255 6 30ZM30 9C18.402 9 9 18.402 9 30s9.402 21 21 21 21-9.402 21-21S41.598 9 30 9Z" })));
});
